'use strict';

import AOS from 'aos';
import Bibliographic from "./components/bibliographic";
import BigNumbers from "./components/big-numbers";
import Footer from "./components/footer";
import Header from "./components/header";
import OurExecitives from "./components/our-executives";
import OurOperation from "./components/our-operation";
import Potential from "./components/potential";
import Contact from './components/contact';


// Warning: this code is only to production redirect
if (window.location.pathname.includes('/en/global') && window.location.host.includes('raizen.com.br')) {
    window.location.href = 'https://www.raizen.com.br/en';
}

export default class App {
    constructor() {

        new Header();
        new Footer();

        AOS.init({
            duration: 1500,
            once: true,
          })

        const ModuloBigNumbers = document.querySelector('.big-numbers');
        const ModuloOurOperation = document.querySelector('.our-operation');
        const ModuloPotential = document.querySelector('.potential');
        const ModuloOurExecutives = document.querySelector('.our-executives');
        const ModuloBibliographic = document.querySelector('.bibliographic');
        const ModuloContact = document.querySelector('.contact');

        ModuloOurOperation ? new OurOperation() : null;
        ModuloBigNumbers ? new BigNumbers() : null;
        ModuloPotential ? new Potential() : null;
        ModuloOurExecutives ? new OurExecitives() : null;
        ModuloBibliographic ? new Bibliographic() : null;
        ModuloContact ? new Contact() : null;
    }
}

new App();